import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { SMALL_TEXT_PX, PRIMARY_FONT_COLOR, X_SMALL_TEXT_PX, TITLE_FONT_COLOR,
    RED_FONT_COLOR, 
    FONT_FAMILY_REGULAR,GREY_PRODUCT_LIST_COLOR} from '../../../styles/fonts/MCFontConstants';

export const ItemListViewWrapper = styled.div.attrs(
    props => ({ id: props.id || 'item-list-view-wrapper' })
)`
    margin-bottom: ${({ marginBottom }) =>
        marginBottom ? marginBottom : '0.5%'};
    width: ${({ width }) => width && width};
    padding: ${({ desktopPading }) => desktopPading && desktopPading};
    ${media.mobileDevice`
    padding: ${({ padding }) => padding && padding};
`}
`;

export const NoMatchError=styled.div`
    color:${RED_FONT_COLOR};
    font-family: ${FONT_FAMILY_REGULAR};
    opacity: 0.7;
    font-size: ${X_SMALL_TEXT_PX};
    margin-top: 2px;
`;

export const ItemTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    font-family: 'AvenirNextWorld demi';
    font-size: 14px;
    border-bottom: ${({ borderBottom }) =>
        borderBottom ? borderBottom : '1px solid #ddd'};
    table-layout: fixed;
    margin-bottom: ${({ isQuickOrder }) =>
        isQuickOrder ? '80px' : '0px'};
`;

export const TableHeaderContainer = styled.thead`
    position: ${({ position }) => (position ? position : 'static')};
    z-index: ${({ zIndex }) => (zIndex)};
    top: ${({ top }) => (top)};
    height: ${({ height }) => (height)};
    font-family: 'AvenirNextWorld demi';
`;


export const CheckBoxContainer = styled.div`
    padding-top: -2px;
    display: flex;
    align-items: flex-start;
    justify-content: center;
     margin-left: ${({ isTemplateScreen }) => (isTemplateScreen ? '0px' : '-51px')};

    @media (min-width: 1024px) and (max-width: 1366px) {
        margin-left: ${({ isAddToBundle }) =>  
            isAddToBundle ? '0px' : '-51px'
        };
    }
`;

export const TableHeader = styled.th`
    background-color: ${({ isSubItem }) => (isSubItem ? '#f5f5f5cc' : 'white')};
    color: ${PRIMARY_FONT_COLOR};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : X_SMALL_TEXT_PX )};
    width: ${({ width }) => width && width};
    font-weight: bold;
    padding: ${({ isForProductGuide,isForSetItem }) => ((isForProductGuide || isForSetItem ) ? '7px 0px' : '7px 10px')};
    text-align: left;
    padding-left: ${({ isSubItem, paddingLeft }) =>
        paddingLeft && isSubItem && '2.5%'};
    border-bottom: 1px solid #ddd;
    white-space: nowrap;

    &.quantity {
        text-align: center;
    }
    &.uom-wrapper {
        text-align: ${({ textAlign }) => textAlign || 'right'};
        padding: ${({ padding, isScheduleSurgery }) => isScheduleSurgery ? '7px 10px ' : padding ? padding : '7px 10px'};
        ${media.ipadAir`
            padding: ${({ isSubItem, isForProductGuide }) => isSubItem ? '0' : isForProductGuide ? '7px 2%' :  '7px 10px'};
        `}
    } 
    &.uom {
        text-align: right;
        margin-right: 5px;
    }
    &.quantityUoM {
        text-align: ${({isTemplateScreen}) => isTemplateScreen ? 'right' : 'center'};
    }
    &.batch {
        text-align: left;
    }
    &.checkBox {
        width: 11%;
    }
    ${media.mediumDevice`
    &.quantity {
        padding-right: 5px;
    }
`}
@media screen and (min-width: 768px) and (max-width: 768px) and (orientation: portrait){     
padding: ${({ ipadPadding }) => (ipadPadding ? ipadPadding : '')};
padding-left:${({ ipadPaddingLeft }) => (ipadPaddingLeft ? ipadPaddingLeft : '')};
}
${media.ipadAir` 
      padding: ${({ ipadAirPadding }) => (ipadAirPadding ? ipadAirPadding : '')}; 
      padding-left:${({ ipadAirPaddingLeft }) => (ipadAirPaddingLeft ? ipadAirPaddingLeft : '')};
    `}
`;

export const TableData = styled.td`
    padding: ${({ isSubItem, padding, isScheduleSurgery }) =>
        isSubItem ? '8px 8px 8px 2.5%' : padding ? padding : isScheduleSurgery? '8px 10px' : '8px 8px'};
    font-family: 'AvenirNextWorld Regular';
    font-size: ${({ isReviewSubmitScreenEquity }) =>
        isReviewSubmitScreenEquity ? '13px' : SMALL_TEXT_PX};
    width: ${({ width }) => width && width};
    border-bottom: ${({ borderBottom }) => borderBottom && borderBottom};
    text-align: ${({ textAlign }) => textAlign ?  textAlign : 'left'};
    &.quantity {
        text-align: ${({ alignLeft, alignCenter }) => (alignLeft ? 'left' : alignCenter ? 'center' : 'right')};
        padding-right: 10px;
        padding-left: 10px;
        font-weight: 400;
    }
    &.price {
        text-align: ${({ alignLeft }) => (alignLeft ? 'left' : 'right')};
        padding-right: 10px;
    }

    &.delete {
        text-align: center;
        padding-left: ${({ paddingDelete }) =>
            paddingDelete ? paddingDelete : '4%'};
    }

    &.description {
        // display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        // padding-left : ${({ paddingLeft }) => (paddingLeft ? paddingLeft : '10px')};
        padding-left: ${({ isForProductGuide, paddingLeft, isFromSetItemDetailsLists }) =>
            isForProductGuide ? '0px' : isFromSetItemDetailsLists ? '0px' :(paddingLeft ? paddingLeft : '10px')};
    }

    &.product {
        color: ${TITLE_FONT_COLOR};
        //font-weight: bold;
        font-family: 'AvenirNextWorld demi';
        //cursor: pointer;
    }
    &.quantityUoM {
        text-align: ${({isTemplateScreen}) => isTemplateScreen ? 'right' : 'center'};
    }
    &.dropdown {
        padding-right: 38px;
    }
    &.batch {
        padding: 0px 0px;
        height: 45px;
    }
        @media screen and (min-width: 768px) and (max-width: 768px) and (orientation: portrait){     
        padding: ${({ ipadPadding }) => (ipadPadding ? ipadPadding : '')};
        padding-left:${({ ipadPaddingLeft }) => (ipadPaddingLeft ? ipadPaddingLeft : '')};
        }
        ${media.ipadAir` 
              padding: ${({ ipadAirPadding }) => (ipadAirPadding ? ipadAirPadding : '')}; 
              padding-left:${({ ipadAirPaddingLeft }) => (ipadAirPaddingLeft ? ipadAirPaddingLeft : '')};
            `}
`;
export const clickHandle = styled.td`
    cursor: pointer;
`;
export const TableRow = styled.tr`
    background-color: ${({ index, isSubItem, parentIndex }) =>
        isSubItem
            ? parentIndex % 2 === 0
                ? GREY_PRODUCT_LIST_COLOR
                : 'white'
            : index % 2 === 0
            ? GREY_PRODUCT_LIST_COLOR
            : 'white'};
    // &:nth-child(even) {
    //     background-color: #f5f5f5cc;
    // }

    // &:nth-child(odd) {
    //     background-color: white;
    // }

    // &:hover {
    //   background-color: #e0e0e0;
    // }
`;

export const ProductCfn = styled.div`
    font-family: 'AvenirNextWorld Demi';
    font-size: 18px;
    font-weight: 600;
    line-height: 31.28px;
    color: #1010eb;
`;

export const ProductData = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    cursor: pointer;
`;

export const Quantity = styled.div`
    font-family: 'AvenirNextWorld Regular';
    font-size: 16px;
    font-weight: 400;
    line-height: 27.81px;
    color: #000000c4;
`;

export const ProductContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 10px 4% 10px 4%;
    border-top: ${({ borderTop }) => borderTop && borderTop};
    border-bottom: ${({ borderBottom }) => borderBottom && borderBottom};
    &:nth-child(even) {
        background-color: #f5f5f5cc;
    }

    &:nth-child(odd) {
        background-color: white;
    }
`;

export const TypeText = styled.div`
    background: #ebebeb 0% 0% no-repeat padding-box;
    border-radius: 43%;
    display: inline;
    padding-left: 9px;
    padding-right: 9px;
    margin-left: 5px;
    color: #140f4b;
    font-size: 13px;
    text-align: center;
    white-space : nowrap;
`;

export const Description = styled.div`
    font-family: 'AvenirNextWorld Regular';
    font-size: 13px;
    font-weight: 400;
    line-height: 22.59px;
    color: #3c3c3c;
`;

export const Brands = styled.div`
    display: flex;
    font-family: 'AvenirNextWorld Regular';
    font-size: 13px;
    font-weight: 700;
    line-height: 22.59px;
    color: #3c3c3c;
`;

export const BrandsName = styled.div`
    display: block;
    font-family: 'AvenirNextWorld Regular';
    font-size: 13px;
    font-weight: 400;
    line-height: 22.59px;
    color: #3c3c3c;
`;

export const Circle = styled.div`
    display: flex;
    align-items: center;
    width: 22px;
    height: 22px;
    border: 1px solid;
    border-radius: 50%;
    justify-content: center;
    color: #dedee4;
    margin-left: 2.5%;
`;

export const ErrorTableRow = styled.tr`
    background-color: ${({ index }) =>
        index % 2 === 0 ? 'white' : '#f5f5f5cc'};
    // &:nth-child(even) {
    //     background-color: #f5f5f5cc;
    // }

    // &:nth-child(odd) {
    //     background-color: white;
    // }
`;

export const InputBox = styled.input.attrs(() => ({
    enterKeyHint: 'go',
}))`
    font-family: 'AvenirNextWorld Regular';
    border: ${({ border }) => (border ? border : '2px solid #ececec')};
    font-size: 13px;
    text-align: center;
    margin: auto 3px;
    border-radius: 4px;
    color: #000000;
    opacity: 1;
    opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
    pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
    height: ${({ height }) => (height ? height : '35px')};
    width: ${({ width }) => (width ? width : '35px')};
    background-color: ${({ mbBackGroundColor }) =>
            mbBackGroundColor ? mbBackGroundColor : 'transparent'};
`;

export const CheckMarkImg = styled.img`
    width: 31px;
    height: 31px;
    object-fit: contain;
`;